import * as axios from "axios";
/**
 * for develop on localhost
 */
import {orders} from './MockOrders';
import auth from '../cognito-auth/cognitoAuth';

/**
 * Get all orders for unit tests
 * @returns {Promise<*>} Promise to return all orders
 */
 export async function getMockOrders() {

  let response = orders;
  return response.active;
}

export async function getOrdersGraphQl(requestBody) {
   
  var token = auth.auth.getSignInUserSession().getIdToken().jwtToken;
  return await axios({
    method: "POST",
    url: process.env.VUE_APP_GQLAPI_URL,
    data: {
      query: `
        query listOrders { 
          listOrders(limit: ${requestBody.limit}, from_index: ${requestBody.from_index}) {
            items {
            id
            applicant {
              title
              surname
              name
              phone_number
              email
              additional_phone_number
              preferred_contact_channel
              address {
                street
                street_number
                city
                country
                zip
              }
              alternative_invoice_address{
                street
                street_number
                city
                country
                zip
              }
            }
            alternative_invoice_recipient{
              title
              surname
              name
              address {
                street
                street_number
                city
                country
                zip
              }
            }
            alternative_invoice
            coordinates {
              lat
              lng
            }
            user_id
            journey
            appointment_for_connection
            appointment_for_connection_presentable
            electric_installations
            gas_installations
            gas_less_than_5m_selected
            e_mobility_installation
            e_charging_station_controllable_selected
            number_of_charging_station
            number_of_charging_points
            electricity_pricings {
              e_charging_station
              heat_pump
              water_heater
            }
            installation_company_electricity_presentable
            installation_company_electricity
            installation_company_gas_presentable
            installation_company_gas
            journey
            number_of_charging_points
            number_of_charging_station	
            own_contribution_selected
            permissions {
              perm_contract
              perm_customer_satisfaction
              perm_forward_personal_dat
            }
            product
            products
            product_installation_full_address{
              street
              street_number
              city
              country
              zip
            }
            status
            uploaded_file_names_blueprint
            uploaded_file_names_cadastral
            request_date
            presentable_installations
            same_landowner
            landowner{
              title
              surname
              name
              address{
                street
                street_number
                city
                country
                zip
              }
            }
            additional_contact_person {
              name
              surname
              title
              email
              phone_number
              additional_phone_number
              preferred_contact_channel
            }
            invoice_address {
              name
              title
              surname
              address{
                street
                street_number
                city
                country
                zip
              }
            }
            combined_pricings{
              total
              electricity_pricings{
                price
              }
              gas_pricings{
                price
              }
              emobility_pricings{
                price
              }
              water_pricings{
                price
                water_building_costs
              }
            }
            product_installation_with_plot_number_address {
              district
              landing
              location
              new_building_area_name
              plot
              zip
            }
            assembly_electricity_company {
              company_name
              contact_person
              construction_planned_date {
                dates
                start_time {
                  start_hour
                  start_minute
                }
                end_time {
                  end_hour
                  end_minute
                }
              }
            }
            assembly_gas_water_company {
              company_name
              contact_person
              construction_planned_date {
                dates
                start_time {
                  start_hour
                  start_minute
                }
                end_time {
                  end_hour
                  end_minute
                }
              }
            }
            groundwork_company {
              company_name
              contact_person
              groundwork_by_client
              construction_planned_date {
                dates
                start_time {
                  start_hour
                  start_minute
                }
                end_time {
                  end_hour
                  end_minute
                }
              }
            }
            internal_construction_management {
              construction_manager
              construction_planned_date {
                dates
                start_time {
                  start_hour
                  start_minute
                }
                end_time {
                  end_hour
                  end_minute
                }
              }
              regional_team {
                team_id
                team_name
              }
            }
            last_changed_by
            last_update
            regional_team {
              team_id
              team_name
            }
          }
          count_orders
          }
        }`
    },
    headers: {
      'Authorization': `${token}`,
      'Content-Type': 'application/graphql'        
    }
  });
}